import { render } from "./PicCarousel.vue?vue&type=template&id=2625af5d&scoped=true"
import script from "./PicCarousel.vue?vue&type=script&lang=js"
export * from "./PicCarousel.vue?vue&type=script&lang=js"

import "./PicCarousel.vue?vue&type=style&index=0&id=2625af5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2625af5d"]])

export default __exports__